// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-error-before-async').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-error-before-async/build.source.js
// module id = 277
// module chunks = 11